var styles = {
  "ChoiceChildren": "Polaris-ChoiceList__ChoiceChildren"
};

export { styles as default };
